import React from 'react';
import { motion } from 'framer-motion';
import { Check, Star, ShieldCheck, Zap } from 'lucide-react';
import { CountdownTimer } from './CountdownTimer';
import { DeviceMockups } from './DeviceMockups';
export function Hero() {
  return <section className="relative pt-48 pb-20 lg:pt-48 lg:pb-32 overflow-hidden" data-id="element-364">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-365">
        <div className="grid lg:grid-cols-2 gap-12 lg:gap-8 items-center" data-id="element-366">
          {/* Left Column - Copy */}
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.6
        }} className="max-w-2xl" data-id="element-367">
            <div className="mb-6" data-id="element-368">
              <CountdownTimer data-id="element-369" />
            </div>
            <h1 className="text-4xl sm:text-5xl lg:text-[52px] font-serif font-bold leading-[1.1] text-ink mb-6" data-id="element-370">
              Tu alimentación cambia en 30 días.
              <br data-id="element-371" />
              <span className="text-gold" data-id="element-372">Elegí el kit diseñado para vos.</span>
            </h1>
            <p className="text-lg text-ink-light mb-8 leading-relaxed" data-id="element-373">
              Más de 100 recetas saludables + planificación inteligente + listas
              de compras listas para llevar al supermercado o dietética sin
              pensar qué comprar.
              <br data-id="element-374" />
              Acceso inmediato desde cualquier dispositivo.
            </p>
            <ul className="space-y-4 mb-10" data-id="element-375">
              {['Ahorrá tiempo cada semana', 'Dejá de improvisar comidas', 'Sentite mejor sin dietas extremas'].map((benefit, i) => <li key={i} className="flex items-center gap-3 text-ink font-medium" data-id="element-376">
                  <div className="flex-shrink-0 w-6 h-6 rounded-full bg-combo-green/10 flex items-center justify-center" data-id="element-377">
                    <Check className="w-4 h-4 text-combo-green" data-id="element-378" />
                  </div>
                  {benefit}
                </li>)}
            </ul>
            <div className="flex flex-wrap gap-4 mb-10" data-id="element-379">
              <div className="flex items-center gap-2 text-sm font-medium text-ink-light bg-white px-3 py-1.5 rounded-full shadow-sm border border-ink/5" data-id="element-380">
                <Star className="w-4 h-4 text-gold fill-gold" data-id="element-381" />
                +7000 personas ya lo tienen
              </div>
              <div className="flex items-center gap-2 text-sm font-medium text-ink-light bg-white px-3 py-1.5 rounded-full shadow-sm border border-ink/5" data-id="element-382">
                <ShieldCheck className="w-4 h-4 text-combo-navy" data-id="element-383" />
                Validado por nutricionistas
              </div>
              <div className="flex items-center gap-2 text-sm font-medium text-ink-light bg-white px-3 py-1.5 rounded-full shadow-sm border border-ink/5" data-id="element-384">
                <Zap className="w-4 h-4 text-combo-burgundy" data-id="element-385" />
                Acceso inmediato
              </div>
            </div>
            <div className="flex flex-col sm:flex-row gap-3" data-id="element-386">
              <a href="#kits" className="bg-combo-green text-white px-6 py-3 rounded-full font-medium text-sm hover:bg-combo-green/90 transition-all text-center min-h-[48px] flex items-center justify-center" data-id="element-387">
                🥗 Alimentación Completa
              </a>
              <a href="#kits" className="bg-combo-navy text-white px-6 py-3 rounded-full font-medium text-sm hover:bg-combo-navy/90 transition-all text-center min-h-[48px] flex items-center justify-center" data-id="element-388">
                ❤️ Salud Cardiovascular
              </a>
              <a href="#kits" className="bg-combo-burgundy text-white px-6 py-3 rounded-full font-medium text-sm hover:bg-combo-burgundy/90 transition-all text-center min-h-[48px] flex items-center justify-center" data-id="element-389">
                💪 Fitness & Proteínas
              </a>
            </div>
          </motion.div>
          {/* Right Column - Mockups */}
          <div className="relative lg:h-full" data-id="element-390">
            <DeviceMockups data-id="element-391" />
          </div>
        </div>
      </div>
    </section>;
}